import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
Vue.use(VueI18n)

let defaultLanguage = 'zh'
// if (global_config.language.open) {
//   if (global_config.language.default === 'client') {
//     defaultLanguage = navigator.language.includes('en') ? 'en' : 'zh'
//   } else {
//     defaultLanguage = global_config.language.default
//   }
// }

if (global_config.language.default === 'client') {
  defaultLanguage = navigator.language.includes('en') ? 'en' : 'zh'
} else {
  defaultLanguage = global_config.language.default
}
let i18n = new VueI18n({
  locale: defaultLanguage,
  messages: {
    zh,
    en
  }
})

export default i18n
